import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchBootstrap, fetchNews } from "@/lib/cms";

const ContentContext = createContext(null);

const EMPTY = {
  company: {},
  stats: [],
  mission_vision: { vision: [], mission: [] },
  offer: {},
  support_categories: [],
  product_categories: [],
  page_banners: {},
  page_headers: {},
  group_strength: [],
  dealer_summary: { total_dealers: 0, total_retailers: 0, divisions: 0, regions: [] },
  dealer_stats: [],
  core_values: [],
  brands: [],
  team: [],
  services: [],
  reviews: [],
  dealers: [],
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(EMPTY);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [b, n] = await Promise.all([fetchBootstrap(), fetchNews()]);
      setContent({ ...EMPTY, ...b });
      setNews(n);
    } catch (e) {
      // keep defaults
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <ContentContext.Provider value={{ content, news, loading, refresh: load }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
